import styled from 'styled-components/macro';
import {
  compose,
  typography,
  space,
  color,
  layout,

  // types
  ColorProps,
  TypographyProps,
  SpaceProps,
  LayoutProps,
} from 'styled-system';

type PProps = ColorProps & TypographyProps & SpaceProps & LayoutProps;

const P = styled.p<PProps>`
  ${compose(color, typography, space, layout)};
`;

P.defaultProps = {
  mx: 0,
  my: 1,
};

export default P;
